<div class="header">
  <button class="back-button" (click)="goToDashboard()"><mat-icon class="back-icon">chevron_left</mat-icon></button>
  <h1>{{ lesson.title }}</h1>
</div>
<div class="lesson-container">
  <h2>{{ lessonPages[currentIndex]?.title }}</h2>

  <div class="page-navigation">
    @for (page of lessonPages; track page; let i = $index) {
      <div
        class="nav-step"
        [class.visited]="isVisited(i)"
        [class.active]="i === currentIndex"
        [class.line-visible]="isLineVisible(i)"
        >
        <button
          [disabled]="!isVisited(i)"
          (click)="goToPage(i)"
          >
          {{ i + 1 }}
        </button>
      </div>
    }
  </div>

  <div class="lesson-content">
    <app-lesson-page
      [items]="lessonPageItems"
      (answerSelectionChange)="handleAnswerSelectionChange($event)"
      (pressQuizButton)="handlePressQuizButton(selectedAnswers)"
      (onVideoStartedEvent)="handleVideoStarted($event)"
    ></app-lesson-page>
  </div>
  <div class="bear-picture-container">
    <img [src]="picturePath" alt="Picture of a Bear" class="bear-picture">
  </div>
  <div class="bottom-navigation">
    <button (click)="prevPage()" [disabled]="currentIndex === 0">Zurück</button>
    @if (!(currentIndex === lessonPages.length - 1)) {
      <button (click)="nextPage()" [disabled]="currentIndex === lessonPages.length - 1 || !areAllItemsCompleted()">Weiter</button>
    }
    @if (currentIndex === lessonPages.length - 1) {
      <button (click)="completeLesson()" [disabled]="!areAllItemsCompleted()">Abschließen</button>
    }
  </div>
</div>